import React from 'react';

import { PriceText, FontColor } from '@prisjakt/ui/text/variants';
import Currency from '@prisjakt/ui-currency';

type Props = {
  isDeal: boolean;
  price: number;
};

export const Price = (props: Props) => {
  const { isDeal, price } = props;

  return (
    <PriceText color={isDeal ? FontColor.NEGATIVE : undefined}>
      <Currency price={price} />
    </PriceText>
  );
};
